var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStackedLockup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215.92 147.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #007896;\n      }\n\n      .cls-2 {\n        fill: #008779;\n      }\n\n      .cls-3 {\n        fill: #e5be20;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.56,44.22a31.44,31.44,0,0,0-1.45-4.33L112.6,66.39A8.68,8.68,0,0,0,110,72.74V85.91a33.6,33.6,0,0,0,30.59-41.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.93,21.23,112.6,36.56A8.68,8.68,0,0,0,110,42.91V63.32L137.31,36A109.61,109.61,0,0,0,127.93,21.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110,0V33.49L125.48,18A223.32,223.32,0,0,0,110,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M105.94,0A234.41,234.41,0,0,0,90.52,18.07l15.42,15.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.94,42.91a8.68,8.68,0,0,0-2.63-6.35L88.07,21.32A119.72,119.72,0,0,0,78.61,36l27.33,27.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.94,85.91V72.74a8.68,8.68,0,0,0-2.63-6.35L76.79,39.87q-.57,1.37-1,2.61a33.62,33.62,0,0,0,30.11,43.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "8.15 124.19 20.97 124.19 20.97 117.95 8.15 117.95 8.15 107.38 24.96 107.38 24.96 101.14 0 101.14 0 141.47 8.15 141.47 8.15 124.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M68.92,125.41c0-3,.61-5.06,1.85-6.27a7.52,7.52,0,0,1,5.48-1.82h2V109q-6.14,0-9.36,6.12v-5.66H60.77v32h8.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M89.82,114.26v-4.8H81.67v32h8.15V123.79A7.93,7.93,0,0,1,91.75,118a7,7,0,0,1,5.23-2,6.84,6.84,0,0,1,5.2,2,8,8,0,0,1,1.91,5.75v17.68h8.09V123.79a7.93,7.93,0,0,1,1.93-5.75,6.94,6.94,0,0,1,5.23-2,6.84,6.84,0,0,1,5.2,2,8,8,0,0,1,1.91,5.75v17.68h8.08V122.63q0-6.47-3.49-10a12.29,12.29,0,0,0-9.22-3.58,12.49,12.49,0,0,0-11.15,6.47,11.24,11.24,0,0,0-4.42-4.8A12.65,12.65,0,0,0,99.76,109Q92.88,109,89.82,114.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "137.94 101.14 137.94 141.47 146.09 141.47 146.09 124.19 163.42 124.19 163.42 141.47 171.57 141.47 171.57 101.14 163.42 101.14 163.42 117.95 146.09 117.95 146.09 101.14 137.94 101.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M49.29,114.43A11.22,11.22,0,0,0,39.23,109a14.19,14.19,0,0,0-10.86,4.59,16.65,16.65,0,0,0-4.27,11.82,16.79,16.79,0,0,0,4.3,11.87,14.07,14.07,0,0,0,10.78,4.65q6.47,0,10.11-5.84v5.38h8.08v-32H49.29Zm-2.55,17.94a8.2,8.2,0,0,1-11.84,0,9.4,9.4,0,0,1-2.54-6.93,9.26,9.26,0,0,1,2.51-6.88,8.31,8.31,0,0,1,11.87,0,10.62,10.62,0,0,1,0,13.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M195.32,100.56a20.19,20.19,0,0,0-14.67,5.84,19.81,19.81,0,0,0-6,14.82,19.86,19.86,0,0,0,6,14.82,20.13,20.13,0,0,0,14.67,5.83c.46,0,.92,0,1.39-.05l1-.09.21,0c.73-.09,1.48-.23,2.23-.4a17.36,17.36,0,0,0,13.48,6.46v-8.45a8.91,8.91,0,0,1-5.37-1.83,19.47,19.47,0,0,0,6.62-9.51c.12-.37.24-.75.33-1.14a22,22,0,0,0,.71-5.64,19.83,19.83,0,0,0-6-14.79A20.08,20.08,0,0,0,195.32,100.56Zm8.87,30.25a12.81,12.81,0,0,1-17.83,0,13.35,13.35,0,0,1-3.43-9.59,13.33,13.33,0,0,1,3.43-9.59,12.85,12.85,0,0,1,17.83,0q3.41,3.59,3.41,9.59A13.47,13.47,0,0,1,204.19,130.81Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackedLockup);
export default __webpack_public_path__ + "static/media/stackedLockup.6c4591de.svg";
export { ForwardRef as ReactComponent };